export default __webpack_public_path__ + "static/media/linkedin.8fb0cfb6.svg";